import TableLoader from '../../../utils/TableLoader';
import defaultImage from '../../../utils/DefaultImage';
// import TableLoader from '../../../../utils/TableLoader';
// import defaultImage from '../../../utils/DefaultImage';

const AllOrderView = (props) => {

    const {
        viewOrderData,
        isLoading,
    } = props;

    return (
        <>
            <h1 className="text-xl font-bold mb-1 poppins-medium  self-start">Dettaglio Ordine </h1>
            <div className=" dash-table-main w-auto h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow">
                <table className="lg:w-full w-[700px] text-left wine_table">
                    <thead>
                        <tr className="border-b border-[#8B2433]">
                            <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">
                                Sr.no
                            </th>
                            <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">Immagine</th>
                            <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Nome</th>
                            <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Tipologia</th>
                            <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Nazione</th>
                            <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Prezzo</th>
                            <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">IVA%</th>
                            <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Quantità</th>
                            <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">Prezzo totale</th>
                        </tr>
                    </thead>
                    {isLoading ? (
                        <TableLoader />
                    ) : (
                        <tbody>
                            {Array.isArray(viewOrderData) && viewOrderData?.length > 0 ? (
                                viewOrderData?.map((orderInfo, index) => (
                                    <tr key={index} className="border-b border-[#8B2433]/12">
                                        <td className="py-4 text-left poppins-regular">
                                            {orderInfo?.sr_no}
                                        </td>
                                        <td className="pr-2 py-4">
                                            <div className="thumbnail_image rounded-lg w-[50px] h-[60px] bg-white p-1 flex align-center justify-center">
                                                <img
                                                    className="w-100 p-1 h-100 object-contain border border-[#68172394] rounded-lg"
                                                    src={
                                                        orderInfo?.wine?.image && orderInfo?.wine?.image !== ""
                                                            ? orderInfo?.wine?.image
                                                            : defaultImage
                                                    }
                                                    height={50}
                                                    width={50}
                                                />
                                            </div>
                                        </td>
                                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.wine?.name || 'N/A'}</td>
                                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.wine?.product_type || 'N/A'}</td>
                                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.wine?.nation || 'N/A'}</td>
                                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">{orderInfo?.price ? `${orderInfo?.price} €` : 'N/A'}</td>
                                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">22%</td>
                                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                            <span className="inline-flex items-center justify-center bg-[#8B2433A6] text-white rounded-full min-w-[32px] h-[32px]">
                                                {orderInfo?.bottles_quantity || 0}
                                            </span>
                                        </td>

                                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                            {orderInfo?.price && orderInfo?.bottles_quantity
                                                ? (() => {
                                                    const basePrice = orderInfo?.price * orderInfo?.bottles_quantity;
                                                    const taxAmount = basePrice * 0.22;
                                                    const totalPrice = basePrice + taxAmount;
                                                    return `${totalPrice.toFixed(2)} €`;
                                                })()
                                                : 'N/A'}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={9} className="text-center py-4">Nessun ordine trovato</td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
            </div>

            <div className="font-bold text-[#303030] py-2  bg-[#8A2533] text-white border-2 border-[#953543] transition-colors rounded-3xl flex justify-end items-center px-4 gap-x-6 mt-4">
                <span className="w-auto text-left poppins-medium">
                    Pezzi:{" "}
                    {Array.isArray(viewOrderData) && viewOrderData.length > 0
                        ? viewOrderData.reduce((sum, orderInfo) => sum + (parseInt(orderInfo.bottles_quantity) || 0), 0)
                        : 0}
                </span>

                <span className="w-auto text-center poppins-medium">
                    Totale ordine:{" "}
                    {Array.isArray(viewOrderData) && viewOrderData.length > 0
                        ? `${viewOrderData.reduce((sum, orderInfo) => {
                            const basePrice = orderInfo?.price ? orderInfo.price * orderInfo.bottles_quantity : 0;
                            const taxAmount = basePrice * 0.22;
                            return sum + basePrice + taxAmount;
                        }, 0).toFixed(2)} €`
                        : "N/A"}
                </span>

                <span className="w-auto"></span>
            </div>
        </>
    )
}

export default AllOrderView;